module.exports = __webpack_public_path__ + "static/media/grrcon.75240977.png";